// LICENSE : MIT
"use strict";

var _ecmascriptVersionDetector = require("./ecmascript-version-detector");

var types = require("../data/index.json");

module.exports = {
    types: types,
    parse: _ecmascriptVersionDetector.parse
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ecmascript-version-detector/lib/index.js
// module id = 146
// module chunks = 0